<div class="cm-linked-dimension-input">
    <cm-numeric-field
        class="cm-dimension-field"
        [value]="$width()"
        (valueChange)="onWidthChange($event)"
        [label]="$widthLabel()"
        [decimalPlaces]="$decimalPlaces()"
        [placeholder]="$widthPlaceholder()"
        [disabled]="$disabled()"
    />
    <i
        class="far cm-link-icon"
        [class.fa-link]="$preserveAspectRatio()"
        [class.fa-link-slash]="!$preserveAspectRatio()"
        [class.cm-link-icon-forced]="$forcedAspectMode()"
        (click)="toggleLink()"
        [matTooltip]="
            $forcedAspectMode()
                ? 'Width and height are locked to the required aspect ratio'
                : $preserveAspectRatio()
                  ? 'Click to unlink width and height'
                  : 'Click to link width and height'
        "
    ></i>
    <cm-numeric-field
        class="cm-dimension-field"
        [value]="$height()"
        (valueChange)="onHeightChange($event)"
        [label]="$heightLabel()"
        [decimalPlaces]="$decimalPlaces()"
        [placeholder]="$heightPlaceholder()"
        [disabled]="$disabled()"
    />
</div>
